import { ApiResourceBaseClass as a } from "./baseApiCalls.js";
const n = "messaging/templates", o = (i) => i.replace(/@\[.*?\]\((\w+)\)/g, "{{$1}}");
class l extends a {
  /**
   * Retrieves the current conversation router settings.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/messaging/templates`
   *
   * @param {MessageReplyTemplateSortOptions} orderBy - The field to order the reply templates by.
   * @param {boolean} onlyUserCreated - A flag indicating whether to only return user-created reply templates.
   * @returns {Promise<Array<MessageReplyTemplateData>>} A promise resolving to the reply templates.
   */
  getMessageReplyTemplates = async (e = "usage", t = !1) => {
    const { data: s } = await this.get(
      `${n}`,
      {
        order_by: e,
        only_user_created: t
      }
    );
    return s;
  };
  /**
   * Creates a new message reply template.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/messaging/templates`
   *
   * @param {MessageReplyTemplateData} messageReplyTemplateData - The data for the new message reply template.
   * @returns {Promise<MessageReplyTemplate>} A promise that resolves to the created message reply template.
   */
  createMessageReplyTemplate = async (e) => {
    const t = {
      title: e.title,
      content: JSON.stringify({
        _version: "0.1",
        text: o(e.content)
      })
    };
    e.icon && (t.icon = e.icon);
    const { data: s } = await this.post(
      `${n}`,
      t
    );
    return s;
  };
  /**
   * Updates an existing message reply template.
   *
   * HTTP Verb: `PUT`
   * Endpoint URL: `/messaging/templates/{templateId}`
   *
   * @param {string} templateId - The ID of the message reply template to update.
   * @param {MessageReplyTemplateData} payload - The data to update the message reply template with.
   * @returns {Promise<MessageReplyTemplate>} A promise that resolves to the updated message reply template.
   */
  updateMessageReplyTemplate = async (e, t) => {
    const s = {
      title: t.title,
      content: JSON.stringify({
        _version: "0.1",
        text: o(t.content)
      })
    };
    t.icon && (s.icon = t.icon);
    const { data: c } = await this.put(
      `${n}/${e}`,
      s
    );
    return c;
  };
  /**
   * Deletes a message reply template.
   *
   * HTTP Verb: `DELETE`
   * Endpoint URL: `/messaging/templates/{templateId}`
   *
   * @param {string} templateId - The ID of the message reply template to delete.
   * @returns {Promise<boolean>} A promise that resolves to `true` if the message reply template was deleted successfully.
   */
  deleteMessageReplyTemplate = async (e) => {
    const { data: t } = await this.delete(
      `${n}/${e}`
    );
    return t;
  };
}
export {
  n as MESSAGING_REPLY_TEMPLATE_RESOURCE_URI,
  l as MessagingReplyTemplate
};
